import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge v3 groups every `text-*` class by the CSS property it sets
// (font-size vs. color). It knows Tailwind's built-ins (text-sm → font-size,
// text-white → color), but our custom typography utilities (text-body-xs,
// text-title-xl, etc.) are unknown to it. Unknown `text-*` classes default
// into the text-color conflict group, so when cn() sees both `text-body-xs`
// (size) and `text-white` (color) it treats them as conflicting declarations
// for the same CSS property and drops one — whichever comes first loses.
//
// The fix: explicitly register every custom typography utility as a font-size
// class so twMerge puts them in the right conflict group and they never
// silently strip color utilities applied alongside them.
//
// TODO: rename the design-system utilities away from the `text-*` prefix
// (e.g. `ds-body-xs`, `type-title-xl`) so they don't share a namespace with
// Tailwind's color utilities and this manual registration becomes unnecessary.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'body',
            'body-sm',
            'body-xs',
            'body-bold',
            'body-lg',
            'body-bold-lg',
            'body-sm-bold',
            'disclosure',
            'title',
            'title-2xl',
            'title-xl',
            'title-lg',
            'title-md',
            'title-sm',
            'title-xs',
            'subtitle',
            'subtitle-sm',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  // eslint-disable-next-line tailwindcss/no-custom-classname -- plugin treats the `inputs` identifier as a class name
  return twMerge(clsx(inputs))
}
